<template>
  <div class="popupDiv">
    <div class="popupContainer">
      <div class="popupHeader">
        <div class="classIndex">{{ indexText }}</div>
        <div class="title">Video training</div>
      </div>
      <div class="popupBody">
        <div class="info">
          <p class="className">{{ className }}</p>
          <div class="mainCounter">
            <div class="examples">
              <p class="alreadTrain">{{ alreadTrain }}</p>
              <p class="text">examples</p>
            </div>
            <div class="counter">
              {{ counter }}
            </div>
          </div>
        </div>
        <div class="stopBtn" @click="eventEmit('stop')">
          End training
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    classes: Array,
    curIdx: Number,
    count: Number,
  },
  computed: {
    index() {
      if (this.curIdx !== -1) {
        return this.curIdx;
      }
      return 0;
    },
    indexText() {
      return `0${this.index + 1}`.slice(-2);
    },
    className() {
      console.log('this class name', this.index, this.classes);
      return this.classes[this.index].name;
    },
    alreadTrain() {
      return this.classes[this.index].examples;
    },
    counter() {
      return `${this.count}/${this.classes[this.index].trainAmount}`;
    },
  },
  methods: {
    eventEmit(e) {
      this.$emit(e);
    },
  },
};
</script>

<style lang="scss" scoped>
.popupDiv {
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: rgba(40, 40, 40, 0.8);
  top: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  .popupContainer {
    width: 200px;
    height: 200px;
    background-color: #f3f5f9;
    border-radius: 12px;
    position: relative;
    font-weight: bold;
    .popupHeader {
      background-color: #727374;
      height: 40px;
      border-radius: 10px 10px 0 0;
      display: flex;
      font-size: 15px;
      .classIndex {
        margin: auto 14px;
      }
      .title {
        margin: auto;
        margin-left: 8px;
      }
    }
    .popupBody {
      height: 160px;
      background-color: #ffffff;
      padding: 10px 15px 15px 15px;
      border-radius: 0 0 10px 10px;
      .info {
        .className {
          margin: 0;
          margin-bottom: 6px;
          color: #727374;
          font-size: 14px;
          text-align: left;
        }
        .mainCounter {
          display: flex;
          flex-direction: row;
          margin-bottom: 5px;
          .examples {
            display: flex;
            flex-direction: column;
            .alreadTrain {
              margin: 0;
              color: #37ccda;
              font-size: 20px;
              text-align: left;
            }
            .text {
              color: #707070;
              font-size: 14px;
            }
          }
          .counter {
            font-size: 40px;
            color: #37ccda;
            margin-left: 8px;
            width:100px;
            text-align:right;
          }
        }
      }
      .stopBtn {
        width: 170px;
        height: 57px;
        border-radius: 10px;
        border: solid 1px #37ccda;
        color: #37ccda;
        font-size: 23px;
        line-height: 57px;
        cursor: pointer;
        &:hover {
          background-color: #37ccda;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
